import { SxProps } from '@mui/material';

export const IconSx: SxProps = {
  color: '#7A8450',
  fontSize: 20,
  marginRight: 0.5
};

export const ErrorIconSx: SxProps = {
  color: '#d32f2f',
  fontSize: 20,
  marginRight: 0.5
};

export const ProcessingIconSx: SxProps = {
  color: '#9e9e9e',
  fontSize: 20,
  marginRight: 0.5
};

export const DateStackSx: SxProps = {
  flexDirection: 'row',
  alignItems: 'center',
  fontSize: '14px',
  marginTop: 0,
  lineHeight: 1
};

export const DateTextSx: SxProps = {
  fontSize: '14px',
  lineHeight: 1
};

export const InvalidDateTextSx: SxProps = {
  fontSize: '14px',
  lineHeight: 1
};

export const ProcessingTextSx: SxProps = {
  fontSize: '14px',
  lineHeight: 1,
  color: '#9e9e9e'
}; 
